import React from 'react';
import { useRouter } from 'next/router';
import getConfig from 'next/config';

import { logEvent } from 'utils/eventTracking';
import { useInfiniteSubmissions } from 'clients/internal/homeSearch';
import { Flexbox, Text, Grid } from '@morressier/ts';
import { SubmissionCard } from 'components/Cards';
import { SkeletonLoader } from 'containers/Search/Submissions';
import { Container, LoadMoreButton } from './style';

const { publicRuntimeConfig } = getConfig();

const LatestSubmissions = () => {
  const router = useRouter();
  const {
    data: submissions,
    isLoading: isSubmissionsLoading,
    isLoadingMore,
    isReachingEnd,
    size,
    setSize
  } = useInfiniteSubmissions({
    page: 0,
    itemsPerPage: 10
  });

  const onClickSubmission = () => {
    logEvent('HOME_LATEST_SUBMISSIONS_CLICKED');
  };

  const renderSubmissionCard = () => {
    return submissions?.map(submission => (
      <SubmissionCard
        key={submission.id}
        submission={submission}
        submissionId={submission.id}
        logEvent={onClickSubmission}
        cardWidth="auto"
        currentPath={`${publicRuntimeConfig.api_base}${router.asPath}`}
      />
    ));
  };

  const onLoadMore = () => {
    setSize(size + 1);
    logEvent('HOME_LATEST_SUBMISSIONS_LOADED_MORE');
  };

  return (
    <Container>
      <Text
        size="h4_new"
        key="latest-submissions-text"
        fontWeight="bold"
        font="Orleans"
        style={{
          marginTop: '2rem',
          marginBottom: '1rem',
          color: 'var(--color-mono-0)'
        }}
      >
        Recent Research
      </Text>
      <Flexbox
        key="latest-submissions-content"
        justifyContent="space-between"
        flexWrap="wrap"
        flexDirection="column"
        style={{ marginBottom: '4rem' }}
      >
        {isSubmissionsLoading ? (
          <>
            <SkeletonLoader />
            <SkeletonLoader />
            <SkeletonLoader />
            <SkeletonLoader />
          </>
        ) : (
          <>
            <Grid xsmall={1} gap="1rem">
              {renderSubmissionCard()}
            </Grid>
            {!isReachingEnd && (
              <Flexbox justifyContent="center">
                <LoadMoreButton
                  disabled={isLoadingMore}
                  loading={isLoadingMore}
                  onClick={onLoadMore}
                >
                  Show more Research
                </LoadMoreButton>
              </Flexbox>
            )}
          </>
        )}
      </Flexbox>
    </Container>
  );
};
export default LatestSubmissions;
